import loginTypes, { loginSteps } from "./login.types";

const INITIAL_STATE = {
  phoneNumber: "",
  phoneNumber_isValid: true,
  sentCode: "",

  name: "",
  melli: "",
  referralMobile: "",
  survey: [],
  userToken: "",
  cookie: "",
  userName: "",
  password: "",

  step: loginSteps.initial,
  queryObject: {},
  phoneLoginMsg: "",
  phoneLoginMsg_error: "",
  phoneLogin_isLoading: false,

  phoneLoginConfirmMsg: "",
  phoneLoginConfirmMsg_error: "",
  phoneLoginConfirm_isLoading: false,

  userNameLoginConfirmMsg: "",
  userNameLoginConfirmMsg_error: "",
  userNameLoginConfirmMsg_isLoading: "",
};

const loginReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case loginTypes.SET_PHONE_NUMBER:
      return {
        ...state,
        phoneNumber: action.payload,
      };
    case loginTypes.SET_LOGINPHONENUMBER_ISVALID:
      return {
        ...state,
        phoneNumber_isValid: action.payload,
      };

    case loginTypes.SET_SENT_CODE:
      return {
        ...state,
        sentCode: action.payload,
      };

    //
    case loginTypes.SET_NAME:
      return {
        ...state,
        name: action.payload,
      };
    case loginTypes.SET_MELLI:
      return {
        ...state,
        melli: action.payload,
      };
    case loginTypes.SET_REFERALL_MOBILE:
      return {
        ...state,
        referralMobile: action.payload,
      };
    case loginTypes.SET_USER_TOKEN:
      return {
        ...state,
        userToken: action.payload,
      };
    case loginTypes.SET_USER_COOKIE:
      return {
        ...state,
        cookie: action.payload,
      };
    case loginTypes.SET_SURVEY:
      return {
        ...state,
        survey: [...state.survey, action.payload],
      };
    //

    //
    case loginTypes.SET_USERNAME:
      return {
        ...state,
        userName: action.payload,
      };
    case loginTypes.SET_PASSWORD:
      return {
        ...state,
        password: action.payload,
      };
    //

    // step
    case loginTypes.SET_LOGIN_STEP:
      return {
        ...state,
        step: action.payload,
      };
    //

    // phone login confirm
    case loginTypes.FETCH_LOGINPHONECONFIRM_START:
      return {
        ...state,
        phoneLoginConfirm_isLoading: true,
      };
    case loginTypes.FETCH_LOGINPHONECONFIRM_SUCCESS:
      return {
        ...state,
        phoneLoginConfirm_isLoading: false,
        phoneLoginConfirmMsg: action.payload,
      };
    case loginTypes.FETCH_LOGINPHONECONFIRM_FAILURE:
      return {
        ...state,
        phoneLoginConfirm_isLoading: false,
        phoneLoginConfirmMsg_error: action.payload,
      };
    //

    // phone login
    case loginTypes.FETCH_LOGINPHONE_START:
      return {
        ...state,
        phoneLogin_isLoading: true,
      };
    case loginTypes.FETCH_LOGINPHONE_SUCCESS:
      return {
        ...state,
        phoneLogin_isLoading: false,
        phoneLoginMsg: action.payload,
      };
    case loginTypes.FETCH_LOGINPHONE_FAILURE:
      return {
        ...state,
        phoneLogin_isLoading: false,
        phoneLoginMsg_error: action.payload,
      };
    //

    // username login
    case loginTypes.FETCH_LOGINUSERNAMECONFIRM_START:
      return {
        ...state,
        userNameLogin_isLoading: true,
      };
    case loginTypes.FETCH_LOGINUSERNAMECONFIRM_SUCCESS:
      return {
        ...state,
        userNameLogin_isLoading: false,
        userNameLoginMsg: action.payload,
      };
    case loginTypes.FETCH_LOGINUSERNAMECONFIRM_FAILURE:
      return {
        ...state,
        userNameLogin_isLoading: false,
        userNameLoginConfirmMsg_isLoading: action.payload,
      };
    case loginTypes.SET_QUERY_OBJECT:
      return {
        ...state,
        queryObject: action.payload,
      };
    //

    default:
      return state;
  }
};

export default loginReducer;
